import * as React from 'react'

export const LinkButton: React.FC<{
  text: string
  link: string
  extraClass: string
  target?: string
  onClick?: () => void | undefined
}> = ({ text, link, extraClass, target = '', onClick = () => {} }) => (
  <a className={`btn ${extraClass}`} href={link} target={target} onClick={onClick}>
    {text}
  </a>
)
